
import { Component, Vue, Prop } from 'vue-property-decorator';
import { OrderComplainModel } from '@/models/order-complain';

@Component
export default class OrderComplain extends Vue {
    @Prop({default: []})
    private orderComplains!: OrderComplainModel[];

    private async viewComplain(complain: any) {
        const routeData = this.$router.resolve({ name: 'detail-order-complain', params: { orderId: complain.orderId, complainId: complain.id } });
        window.open(routeData.href, '_blank');
    }
}
